import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'nl', label: 'Nederlands' },
];

const LanguageTab: React.FC = () => {
  const { t, i18n } = useTranslation(['common', 'screens']);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div className="p-3">
      <h5>{t('screens:settings.tabs.language')}</h5>
      <div className="mb-3" style={{ maxWidth: 300 }}>
        <label className="form-label">{t('common:language')}</label>
        <select
          className="form-select"
          value={i18n.language.split('-')[0]}
          onChange={handleChange}
        >
          {LANGUAGES.map(lang => (
            <option key={lang.code} value={lang.code}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LanguageTab;
